<template>
    <div id="sig-container" class="block full form-horizontal">
        <form @submit.prevent="guardarCasaCobranza">
            <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
            <div class="widget">
                <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                    <span class="float-right text-muted">
                        <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
                    </span>
                    Gestión
                </div>
                <div class="widget-content border-bottom themed-background-muted text-center">
                    <div class="container">
                        <div class="row mt-2">
                            <label for="" class="col-3 control-label text-right"><strong>Nit</strong></label>
                            <div class="col-9">
                                <input type="text" v-model="casa.nit" id="nit" class="form-control" placeholder="Nit">
                            </div>
                        </div>
                        <div class="row mt-2" v-bind:class="{'has-error': errors?errors['nit']:false}">
                            <div class="col-9 offset-3">
                                <span class="help-block" v-if="errors?errors['nit']:false">{{ errors?errors['nit'][0]:'' }}</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <label for="" class="col-3 control-label text-right"><strong>Nombre</strong></label>
                            <div class="col-9">
                                <input type="text" v-model="casa.nombre" id="nombre" class="form-control" placeholder="Nombre">
                            </div>
                        </div>
                        <div class="row mt-2" v-bind:class="{'has-error': errors?errors['nombre']:false}">
                            <div class="col-9 offset-3">
                                <span class="help-block" v-if="errors?errors['nombre']:false">{{ errors?errors['nombre'][0]:'' }}</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <label for="" class="col-3 control-label text-right"><strong>Teléfono</strong></label>
                            <div class="col-9">
                                <input type="text" v-model="casa.telefono" id="telefono" class="form-control" placeholder="Teléfono">
                            </div>
                        </div>
                        <div class="row mt-2" v-bind:class="{'has-error': errors?errors['telefono']:false}">
                            <div class="col-9 offset-3">
                                <span class="help-block" v-if="errors?errors['telefono']:false">{{ errors?errors['telefono'][0]:'' }}</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <label for="" class="col-3 control-label text-right"><strong>Dirección</strong></label>
                            <div class="col-9">
                                <input type="text" v-model="casa.direccion" id="direccion" class="form-control" placeholder="Dirección">
                            </div>
                        </div>
                        <div class="row mt-2" v-bind:class="{'has-error': errors?errors['direccion']:false}">
                            <div class="col-9 offset-3">
                                <span class="help-block" v-if="errors?errors['direccion']:false">{{ errors?errors['direccion'][0]:'' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 offset-md-3 text-center mt-3">
                                <button class="btn btn-sm btn-info">{{ casa.id?'Editar':'Guardar' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'Crear-EditarCasaCobranza',
    data: () => {
        return {
            casa: {},
            errors: null
        }
    },
    computed: {
        ...mapGetters({'loading': 'loading'})
    },
    methods: {
        guardarCasaCobranza() {
            this.$store.dispatch('store', {endpoint: 'administracion/casascobranza', params: this.casa})
            .then(response => {
                this.$notify({
                    title: 'Casas de Cobranza',
                    type: 'success',
                    content: 'La acción se completó con éxito',
                })
            })
            .catch(error => {
                this.errors = error.data.errors;
                this.$notify({
                    title: 'Casas de Cobranza',
                    type: 'warning',
                    content: 'Los datos dados no son válidos',
                })
            })
        }
    },
    mounted() {
        if (this.$route.params.id) {
            this.$store.dispatch('show', {endpoint: 'administracion/casascobranza', id: this.$route.params.id})
            .then(response => {
                this.casa = response
            })
            .catch(error => {
                switch(error.status) {
                    case 404:
                        this.$notify({
                            title: 'Casas de Cobranza',
                            type: 'warning',
                            content: 'Casa de cobranza no encontrada',
                        })
                        break;
                    default: 
                        this.$notify({
                            title: 'Casas de Cobranza',
                            type: 'error',
                            content: 'Ha ocurrido un error, por favor comuníquese con un administrador del sistema',
                        })
                        break;
                }
            })
        }
    }
}
</script>